class Device {
    static type = 'web'

    static getDevice(){
        if(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)){
            this.type = 'phone'
        }else{
            this.type = 'web'
        }
    }

    static isMobile(){
        return this.type === 'phone'
    }
}

export {
    Device
}


// WEBPACK FOOTER //
// ./src/lib/device.js